/**
 * Модуль закрытия кнопки с вопросом рождения малыша
 * А так же логика его показа при куках
 */
itsoftApp.createModule('closeBornWidget', function () {
  // Локальные переменные
  const module = this;
  const closeBtn = document.getElementById('popup-born-close');
  const popupWidget = document.getElementById('popup-born-button');
  const babyPageUrl = '/page-new-born.php'; // Страница младенцы
  const kidsPageUrl = '/page-product-baby.php'; // Страница дети
  const path = location.pathname;
  const nameCookieForBaby = 'babyBornPopup';
  const nameCookieForKids = 'hideForAllPages';

  const currentCookie = getCookie(nameCookieForBaby);
  const hideForAllPages = getCookie(nameCookieForKids);

  if (hideForAllPages) {
    // Если код уже получен, то скрыть вообще для всех людей
    hideWidget();
  } else {
    // Если есть - проверка на страницы
    if (currentCookie) {
      // Если это страница дети или страница младенцы, то показываем, а на остальных скрываем
      if (path !== babyPageUrl && path !== kidsPageUrl) {
        hideWidget()
      }

    } else {
      let date = new Date(Date.now() + 86400e3).toUTCString();
      document.cookie = `${nameCookieForBaby}=true; path=/; expires=${date}`
    }
  }

  const closeBornWidget = function () {
    if (closeBtn && popupWidget) {
      closeBtn.addEventListener('click', function () {
        popupWidget.classList.add('popup-born-button--hidden')
      })
    }
  };

  function hideWidget() {
    if (popupWidget) popupWidget.style.display = 'none'
  }

  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  closeBornWidget();

  module.callbacks = {
    hideWidget
  }
});
